import { getAdvanced, normalizePageBuilderHtml } from '../../utils'

const configAggregator = (node) => {
    const raw = node.innerHTML || node.textContent || ''
    const { html, cssBlocks } = normalizePageBuilderHtml(raw)

    return {
        richContent: html,
        cssBlocks,
        ...getAdvanced(node)
    }
}

export default configAggregator
